<template>
  <div ref="el">
    <div class="main-question">
      <contenteditable
        tag="p"
        :contenteditable="true"
        v-model="title"
        :noNL="true"
        @input="updateTitle"
      />
    </div>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import contenteditable from "@/components/Contenteditable";

export default {
  mixins: [nodeMixin],
  components: {
    contenteditable,
  },
  data() {
    return {
      title: 'Mensaje (Vista previa de vídeo e imágenes)'
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();

    if (this.nodeData.data.config) {
      if (this.nodeData.data.config.title) {
        this.title = this.nodeData.data.config.title;
      }
    } else {
      this.nodeData.data.config = {};
      this.title = this.nodeData.data.config.title = 'Mensaje (Vista previa de vídeo e imágenes)';
      this.updateNodeConfig();
    }
  },
  methods: {
    updateTitle(value) {
      this.title = value;
      this.updateNodeConfig();
    },
    updateNodeConfig() {
      const currentNode = this.$df.getNodeFromId(this.nodeId);
      this.updateNodeData({
        config: { ...(currentNode.data.config || {}), title: this.title },
      });
    },
  },
};
</script>

<style></style>
